import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import useRequest from "../../../hooks/useRequest";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import { useSelector } from "react-redux";
import {
  Input, RenderInputFields, SubmitButton, SubInput,
  SubTab
} from "../../Form/Form";

const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    control,
    setValue
  } = useForm();

  const { response, request } = useRequest();
  const { languages } = useSelector((state) => state.setting);
  const history = useHistory();
  const [pdf, setPdf] = useState();
  const [displayPdf, setDisplayPdf] = useState();

  useEffect(() => {
    document.title = "Add Document - Calevalab";
  }, []);

  useEffect(() => {
    if (response) {
      toast.success("Document has been added successfully.");
      history.push("/resources/document");
    }
  }, [response]);

  const onSubmit = (data) => {
    const langData = [];
    let fd = new FormData();
    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;

      if (languages[i].default) {
        fd.append("title", data[`title-${code}`]);
        // fd.append("subTitle", data[`subTitle-${code}`]);
      }

      langData.push({ languageCode: code, title: data[`title-${code}`] });
    }

    if (data.pdf && data.pdf.length > 0) {
      fd.append("file", data.pdf[0]);
    }
  
    // fd.append("link", data?.link);

    fd.append("langData", JSON.stringify(langData));
    request("POST", "resource-document", fd);
  };

  const handlePdf = (event) => {
    event.preventDefault();
    if (event.target.files[0]) {
      const file = event.target.files[0];
      if (file.type === "application/pdf") {
        setDisplayPdf(URL.createObjectURL(file));
        setPdf(file);
        setError("pdf", ""); 
      } else {
        setDisplayPdf(""); 
        setPdf(""); 
        setValue("pdf", ""); 
        toast.error("Please select a valid PDF file.");
      }
    } else {
      setDisplayPdf("");
      setPdf("");
      setValue("pdf", ""); 
    }
  };
  

  const handleRemovePdf = () => {
    setPdf(null);
    setDisplayPdf(null);
    setValue("pdf", null);
  };

  const InputFields = [
    [
      {
        Component: Input,
        label: "Title",
        type: "text",
        name: "title",
        registerFields: {
          required: true,
        },
      },
    ],
  ];

  const InputFieldsImage = [
    [
      {
        Component: Input,
        label: "PDF", 
        type: "file", 
        name: "pdf", 
        registerFields: {
          required: true, 
        },
        handleMedia: handlePdf, 
        handleRemoveMedia: handleRemovePdf,  
        isMedia: true, 
        accept:"application/pdf",
        control, 
        pdf,
        displayPdf,  
        media: "pdf", 
        mediaClass: "pdf-tab-media",
      },
    ],
  ];
  
  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Add Document"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/resources/document", name: "Back To Document" },
        ]}
      />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-1"></div>
                <div className="col-xl-10">
                  <h3 className="mb-10 font-weight-bold text-dark">
                    Add New Document
                  </h3>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row"></div>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <>
                                <SubInput
                                  key={index}
                                  index={index}
                                  errors={errors}
                                  register={register}
                                  //   required={lang.default}
                                  required={true}
                                  InputFields={InputFields}
                                  code={lang.code}
                                />
                              </>
                            ))}
                        </div>
                        <div className="row"></div>
                      </div>
                    </div>
                    <div className="row"></div>

                    <RenderInputFields
                      InputFields={InputFieldsImage}
                      errors={errors}
                      register={register}
                    />

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
